import { RESET_STUDIO_ACTION } from '../consts';
import type { Preset } from '../../types/Preset';
import type { StudioPresetsActions } from '../../actions/studio/presets';

export interface State {
    all: Record<string, Preset> | null;
    byCategory: Record<string, Preset[]>;
    byModelName: Record<string, Preset[]>;
    userCreated: Preset[];
}

const getDefaultState = (): State => ({
    all: null,
    byCategory: {},
    byModelName: {},
    userCreated: []
});

const studioPresetsReducer = (state = getDefaultState(), action: StudioPresetsActions | null): State => {
    switch (action?.type) {
        case 'STUDIO_SET_PRESETS': {
            return {
                ...state,
                all: action.data.all,
                byCategory: action.data.byCategory,
                byModelName: action.data.byModelName,
                userCreated: action.data.userCreated
            };
        }

        case RESET_STUDIO_ACTION: {
            return getDefaultState();
        }

        default: {
            return state;
        }
    }
};

export default studioPresetsReducer;
